"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var e = require("react");

exports.default = function (r, t) {
  var n = e.useRef();
  e.useEffect(function () {
    n.current = r;
  }, [r]), e.useEffect(function () {
    if (null !== t) {
      var e = setInterval(function () {
        return n.current.apply(n, arguments);
      }, t);
      return function () {
        return clearInterval(e);
      };
    }
  }, [t]);
};